<template>

  <div>
    <div style="width: 100%;">
      <img src="./abuous01.png" alt="关于我们" style="width: 100%; height: auto;">
    </div>

    <!-- 头部切换 -->
    <div class="wd100 pdtop" style="width: 1255px;margin: 40px auto;position: relative;">
      <div class="breadcrumb">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb-list">
            <li class="breadcrumb-item"><a @click="active('/')">首页></a></li>
            <li class="breadcrumb-item"><a @click="active('/aboutsUs')">关于我们></a></li>
            <li class="breadcrumb-item">荣誉资质</li>
          </ol>
        </nav>
      </div>
    </div>


    <div class="wd100 pdtop pdtopStyle" style="height: 3300px">
      <div>
          <span class="titleSty">荣誉资质
          <span class="spanSty">Qualification honor</span></span>
      </div>

      <div class="containerc">
        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/01.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">高新技术企业证书</p>
        </div>

        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy1.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">恩施州知识产权保护工作站</p>
        </div>

        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy2.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">资产检索分析</p>
        </div>
      </div>

      <div class="containerc">
          <div class="certificate-boxc">
            <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy3.png')" :preview-src-list="srcList"></el-image>
            <p class="certificate-textc">商标品牌指导</p>
          </div>

          <div class="certificate-boxc">
            <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy4.jpg')" :preview-src-list="srcList"></el-image>
            <p class="certificate-textc">湖北省严选服务机构</p>
          </div>

          <div class="certificate-boxc">
            <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy5.jpg')" :preview-src-list="srcList"></el-image>
            <p class="certificate-textc">湖北省级技术转移示范机构</p>
          </div>
      </div>

      <div class="containerc">
        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy6.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">湖北省技术改造咨询诊断服务机构</p>
        </div>

        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy7.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">专精特新发展服务合作机构</p>
        </div>

        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy8.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">公共服务标杆服务机构</p>
        </div>
      </div>

      <div class="containerc">
        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy9.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">公共服务示范平台</p>
        </div>

        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy10.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">湖北省科技创新券服务机构</p>
        </div>

        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy11.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">企校联合创新中心</p>
        </div>
      </div>


      <div class="containerc">
        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy13.jpg')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">湖北省高校毕业生就业见习基地</p>
        </div>

        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy14.jpg')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">AAA级重服务守信用企业</p>
        </div>

        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy15.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">湖北省云服务供应商</p>
        </div>
      </div>


      <div class="containerc">
        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy16.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">科技成果转化基层站点</p>
        </div>

        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy17.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">荆门数字化服务商</p>
        </div>

        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy18.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">工商联合会员</p>
        </div>
      </div>


      <div class="containerc">
        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy19.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">响应系统入选</p>
        </div>

        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy20.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">中小企业志愿服务工作站</p>
        </div>

        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy21.png')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">科惠网恩施分平台建立维护服务</p>
        </div>
      </div>

      <div class="containerc">
        <div class="certificate-boxc">
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy22.jpg')" :preview-src-list="srcList"></el-image>
          <p class="certificate-textc">股份挂牌</p>
        </div>
      </div>

    </div>

    <div class="wd100 pdtop" style="width: 1255px;margin: 0px auto;height: 100px">
    </div>
  </div>


</template>
<style scoped>
@import 'aboutsUsRy.css';
</style>
<script>
import {save} from '@/api/common'

export default {
  data() {
    return {
      srcList: [
        require("../../assets/image/rongyu/01.png"),
        require("../../assets/image/rongyu/yy2.png"),
        require("../../assets/image/rongyu/yy3.png"),
        require("../../assets/image/rongyu/yy4.jpg"),
        require("../../assets/image/rongyu/yy5.jpg"),
        require("../../assets/image/rongyu/yy6.png"),
        require("../../assets/image/rongyu/yy7.png"),
        require("../../assets/image/rongyu/yy8.png"),
        require("../../assets/image/rongyu/yy9.png"),
        require("../../assets/image/rongyu/yy10.png"),
        require("../../assets/image/rongyu/yy11.png"),
        require("../../assets/image/rongyu/yy13.jpg"),
        require("../../assets/image/rongyu/yy14.jpg"),
        require("../../assets/image/rongyu/yy15.png"),
        require("../../assets/image/rongyu/yy16.png"),
        require("../../assets/image/rongyu/yy17.png"),
        require("../../assets/image/rongyu/yy18.png"),
        require("../../assets/image/rongyu/yy19.png"),
        require("../../assets/image/rongyu/yy20.png"),
        require("../../assets/image/rongyu/yy21.png"),
        require("../../assets/image/rongyu/yy22.jpg"),
      ],
      teachers: [],
    }
  },

  methods: {
    active(url) {
      this.$router.push(url);
    },
  },
  mounted: function () {

  },
}
</script>
<style>

.el-carousel__container button{
  background-color: white!important;;
  color: #0788dc;
  border: 2px solid #0788dc;
  font-weight: 500;
  font-size: 16px;
}
.el-carousel__arrow {
  background-color: #0788dc!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/aboutsUs/aboutsUsRy.vue